<div style="text-align: center;">
  <button onclick="window.location.href = '/register/line/insure/route3?redirect=true'">Route 3</button>
</div>